import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { environment } from '@env/environment';
import { NzNotificationRef, NzNotificationService } from 'ng-zorro-antd/notification';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.scss'],
})
export class CustomToastComponent implements OnInit, OnChanges, OnDestroy {
  @Input() public isOpenOrCloseOnInit: boolean = false;
  @Input() public open: boolean = false;
  @Input() public placement: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'top' | 'bottom' = 'bottom';
  @Input() public message: string = '';
  @Input() public type: 'alert' | 'warning' = 'alert';
  @Input() public duration: number;

  @Output() public close: EventEmitter<void> = new EventEmitter<void>();
  @Output() public actionClick: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(TemplateRef, { static: false }) templateToast?: TemplateRef<{}>;

  private currentToastNotificationRef: NzNotificationRef;
  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private notificationService: NzNotificationService) {}

  ngOnInit(): void {
    if (this.isOpenOrCloseOnInit) {
      if (this.open) {
        this.openToast();
      } else {
        this.closeToast();
      }
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const openPreviousValue = changes.open && changes.open.previousValue;
    const currentValue = changes.open && changes.open.currentValue;

    if (currentValue !== openPreviousValue && !changes.open.firstChange) {
      if (this.open) {
        this.openToast();
      } else {
        this.closeToast();
      }
    }
  }

  public ngOnDestroy(): void {
    this.closeToast();
    this.destroy$.next();
  }

  public onActionClick() {
    this.actionClick.emit();
  }

  public openToast() {
    this.createToastNotification();
  }

  public closeToast() {
    if (!!this.currentToastNotificationRef) {
      this.notificationService.remove(this.currentToastNotificationRef.messageId);
      this.currentToastNotificationRef = null;
    }
  }

  public get toastIconSrc(): string {
    let imageSrc = '';

    switch (this.type) {
      case 'alert':
      default:
        imageSrc = 'assets/icons/icon_warning_md_red.svg';
        break;
      case 'warning':
        imageSrc = 'assets/icons/icon_attention_md.svg';
        break;
    }

    return imageSrc;
  }

  private createToastNotification(): void {
    const notification = this.notificationService.template(this.templateToast!, {
      nzClass: 'nz-custom-toast',
      nzDuration: this.duration !== null ? this.duration : environment.alertTime,
      nzPlacement: this.placement,
    });

    notification.onClose.pipe(takeUntil(this.destroy$)).subscribe((_) => {
      this.close.emit();
    });

    this.currentToastNotificationRef = notification;
  }
}
